export enum RoutesFront {
	ADMINISTRACAO = '/administracao',
	METEOROLOGIA = '/meteorologia',
	RECURSOS_HIDRICOS = '/recursos-hidricos',
	HOME = '/',
	DADOS_METEOROLOGICOS = 'dados-meteorologicos',
	DADOS_HIDROLOGICOS = 'dados-hidrologicos',
	PREVISAO_NUMERICA_TEMPO = 'previsao-numerica-tempo',
	ZONEAMENTOS = 'zoneamentos',
	ZONEAMENTOS_AGRICOLAS = 'zoneamentos-agricolas',
	PREVISAO_CLIMATICA = 'previsao-climatica',
	IMAGENS_SATELITE = 'imagens-satelite',
	PREVISAO_VERANICOS = 'previsao-veranicos',
	RESERVATORIOS = 'reservatorio',
	CONFIGURACAO_VERANICO = 'configuracao-veranico',
	CONFIGURACAO_CLASSIFICACAO_RESERVATORIO = 'configuracao-classificacao-reservatorio',
	CAMPANHA_QUALIDADE_AGUA = 'campanha-qualidade-agua',
	HISTORICOS_RESERVATORIO = 'historicos-reservatorio',
	IMAGENS_DO_SISTEMA = 'imagens-sistema',
	ENVIO_DADOS_MASSIVO = '/dados-meteorologicos/monitoramento/envio-de-dados-massivos',
  ENVIO_DADOS_MASSIVO_RESERVATORIO = '/dados-hidrologicos/monitoramento/envio-de-dados-massivos',
}
